<template>
    <div class="table-data-root">
    <div class="table-card-shell tableCornerRadiusForAudit mb-16 bg-white">
    <div class="table-card-inner">
        <div class="table-container table-container-fit">
        <div class="table-header-wrap">
        <table class="table-fit-card table-header-table" :style="tableResizeStyle">
            <colgroup>
                <col v-for="columnName in columnNames" :key="'h-'+columnName" :style="columnStyle(columnName)" />
            </colgroup>
            <thead>
                <tr class="table-header-row">
                <th scope="col" v-for="columnName in columnNames" :key="columnName" class="bg-white capitalize resizable-th" :class="getColumnHeadWidth(columnName)" :style="columnStyle(columnName)" @click="onHeaderClick(columnName)" @mouseout="doFalse()">
                    <div class="flex table-header-label-wrap">
					    <div class="cursor-pointer table-header-label" @mousemove="headerToolTip(columnName, $event)">{{ getColumnLabel(columnName) }}</div>
                        <div class="sort cursor-pointer" :class="className == columnName ? classSort : 'opacity-50'" v-if="getColumnLabel(columnName) != ''"></div>
                    </div>
                    <span class="column-resize-handle" @mousedown.stop.prevent="startColumnResize($event, columnName)"></span>
                    <div v-if="pop == true && tipColumn == columnName && tipIndex == 'header'">
                        <tool-tip :columnName="columnName" :tipText="tipText" :styling="styling"></tool-tip>
                    </div>
                </th>
                </tr>
            </thead>
        </table>
        </div>
        <div class="table-body-scroll">
        <table class="table-fit-card" :style="tableResizeStyle">
            <colgroup>
                <col v-for="columnName in columnNames" :key="'b-'+columnName" :style="columnStyle(columnName)" />
            </colgroup>
            <tbody v-if="sortedData.length == 0">
                <tr class="cursor-pointer empty rowHeight">
                    <td class="relative h-10" :colspan="columnNames.size">
                        <div class="flex justify-center"><p class="text-xs font-normal">No Records Found</p></div>
                    </td>
                </tr>
            </tbody>
            <tbody class="nonEmptyTable" v-else>
                <tr v-for="(row, index) in sortedData" :key="row" class="cursor-pointer rowHeight">
                    <td v-for="columnName in columnNames" :key="columnName" @mouseout="doFalse()" class="cursor-pointer relative" :class="getColumnHeadWidth(columnName)" :style="columnStyle(columnName)">
                        <div v-if="columnName == 'auditee'">
							<!-- <select class="inputboxstyling" v-model="row['auditee']" 
                            :class="{
                                'is-invalid': !v$.sortedData.$each.$response.$data[index].auditee.required
                                }"
                            >
                             	<option value="" selected disabled hidden>Please select one</option>
                                <option v-for="obj in optionsUserArray" :key="obj.id" :value="obj.value">{{ obj.label }}</option>
                          	</select> -->
                            <!-- <multiselect
								v-model="row['auditee']"
								:options="auditeeOptions"
								:showNoOptions="false"
								@search-change="asyncFind"
								:limit-text="limitText"
								:multiple="false"
								:close-on-select="true"
								:clear-on-select="true"
								open-direction="bottom"
								label="label"
								track-by="value"  
                                :hide-selected="true"
                                @select="checkAfterRequired('check')"  
								:searchable="true"
								:hideArrow="false"
								placeholder="Auditee"
								class="custom-multiselect userSelect"
								:class="{
									'is-invalidmultiselect': validationErrors[index]?.auditee || validationErrors[index]?.sameAuditorAuditee,
                                    'has-options': auditeeOptions && auditeeOptions.length > 0,
                                    'no-options': !auditeeOptions.length &&  searchValue !== '',
								}"
							>
                                <template v-slot:noResult>
									<span class="text-xs">No Members Found</span>
								</template>
							</multiselect> -->
                            <AutoComplete
                                v-model="row['auditee']"
                                :suggestions="auditeeOptions"
                                optionLabel="label"
                                placeholder="Auditee"
                                class="w-full custom-multiselect userSelect"
                                :class="{
                                    'p-invalid': validationErrors[index]?.auditee || validationErrors[index]?.sameAuditorAuditee,
                                    'has-options': auditeeOptions && auditeeOptions.length > 0,
                                    'no-options': !auditeeOptions.length && searchValue !== '',
                                }"
                                @complete="asyncFind"
                                @change="checkAfterRequired('check')"
                                />


                             <div class="text-red-500">		
                                <div class="error-text" v-if="validationErrors[index]?.auditee">Required</div>
                                <div class="error-text" v-if="validationErrors[index]?.sameAuditorAuditee">Auditee and Auditor cannot be the same</div>
                            </div>
						</div>
                        <div v-else-if="columnName == 'auditor'">
							<!-- <select class="inputboxstyling" v-model="row['auditor']"
                            :class="{
                                'is-invalid': !v$.sortedData.$each.$response.$data[index].auditor.required
                                }"
                            >
                             	<option value="" selected disabled hidden>Please select one</option>
                                <option v-for="obj in optionsUserArray" :key="obj.id" :value="obj.value">{{ obj.label }}</option>
                          	</select> -->
                            <!-- <multiselect
								v-model="row['auditor']"
								:options="auditorOptions"
								:showNoOptions="false"
								@search-change="asyncFind1"
								:limit-text="limitText"
								:multiple="false"
								:close-on-select="true"
								:clear-on-select="true"
								open-direction="bottom"
                                @select="checkAfterRequired('check')"
								label="label"
                                :hide-selected="true"
								track-by="value"    
								:searchable="true"
								:hideArrow="false"
								placeholder="Auditor"
								class="custom-multiselect userSelect"
								:class="{
									'is-invalidmultiselect': validationErrors[index]?.auditor || validationErrors[index]?.sameAuditorAuditee,
                                    'has-options': auditorOptions && auditorOptions.length > 0,
                                    'no-options': !auditorOptions.length &&  searchValue !== '',
								}"
							>
                                <template v-slot:noResult>
									<span class="text-xs">No Members Found</span>
								</template>
							</multiselect> -->
                            <AutoComplete
                                v-model="row['auditor']"
                                :suggestions="auditorOptions"
                                optionLabel="label"
                                placeholder="Auditor"
                                class="w-full custom-multiselect userSelect"
                                :class="{
                                    'p-invalid': validationErrors[index]?.auditor || validationErrors[index]?.sameAuditorAuditee,
                                    'has-options': auditorOptions && auditorOptions.length > 0,
                                    'no-options': !auditorOptions.length &&  searchValue !== '',
                                }"
                                @complete="asyncFind1"
                                @change="checkAfterRequired('check')"
                            />
                            <div class="text-red-500">		
                                <div class="error-text" v-if="validationErrors[index]?.auditor">Required</div>
                                <div class="error-text" v-if="validationErrors[index]?.sameAuditorAuditee">Auditee and Auditor cannot be the same</div>
                            </div>
						</div>
                        <div v-else-if="columnName=='entity'">
                            <div class="table-ellipsis" @mousemove="toolTip(columnName, $event, index, row, 'text')">
                                    {{row[columnName]  }}
                            </div>
                            <div v-if="pop == true && tipColumn == columnName && tipIndex == index">
                                <tool-tip :columnName="columnName" :tipText="tipText" :styling="styling"></tool-tip>
                            </div>
                        </div>
                        <div v-else-if="columnName=='team'">
                            <div class="table-ellipsis" @mousemove="toolTip(columnName, $event, index, row, 'text')">
                                    {{row[columnName]  }}
                            </div>
                            <div v-if="pop == true && tipColumn == columnName && tipIndex == index">
                                <tool-tip :columnName="columnName" :tipText="tipText" :styling="styling"></tool-tip>
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        </div>
        </div>
        <pagination :dynamicPagination="dynamicPagination" @currentPageUpdate="paginationUpdations" :entityId="entityId" :sortedData="sortedData"></pagination>
    </div>
    </div>
    </div>
    
</template>
<style scoped>
th, td {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: left;
    vertical-align: middle;
}
tr:last-child {
    border-bottom: 1px solid #e9e9e9 ;
}
.w-40 {
    width: 155px;
}
.ellipsis-container {
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    line-height: 1.5em;
    max-height: 3em;
}
.table-ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-break: normal;
    overflow-wrap: normal;
    max-width: 100%;
}
.width20{
    width : 20%
}
.width30{
    width : 30%
}
</style>

<script lang="ts">
import { emitter, toast } from '@/main';
import Multiselect from 'vue-multiselect';
import _ from 'lodash';
import { defineComponent } from 'vue';
import toolTip from '@/components/toolTip.vue';
import pagination from '@/components/pagination.vue';
import useVuelidate from '@vuelidate/core';
import { required, helpers } from '@vuelidate/validators';
import { mapGetters } from 'vuex';
import AutoComplete from 'primevue/autocomplete';
import { columnResizeMixin } from '@/mixins/columnResizeMixin';

export default defineComponent({
    mixins: [columnResizeMixin],
    props: ['tableRowData', 'headersData','locations','departments','userArray'],
    data(): any {
        return {
            v$:useVuelidate(),
            tableHead: [],
            tableRow: [],
            searchTableRow: [],
            entityId: '',
            visibility: false,
            className: '',
            classSort: '',
            currentSort: 'name',
            currentSortDir: 'asc',
            showDropDown: false,
            showBlock: false,
            validationErrors: [],

            currentPage: '',
            pageSize: '',
            dynamicPagination: '',

            pop: false,
            styling: { left: '', bottom: '' },
            tipText: '',
            tipColumn: '',
            tipIndex: '',
            filters: {},
            users: [],
            optionsUserArray: [],
            auditeeList:[],
            selectedRowIndex: '',
            action:'',
            auditeeOptions:[],
            auditorOptions:[],
            userInfoFilteredDetails : {},
            searchValue:'',
             columns:[
                {key:'entity',value:'Location'},
                {key:'teamOwner',value:'team Representative'},
                {key:'reviewer',value:'Reviewer'}
            ]
        };
    },
    validations(){
		return{
            sortedData: {
                $each: helpers.forEach({
                    auditee:{required},
                    auditor:{required}
                })
            }
        }
    },
    components: {
        toolTip,
        Multiselect,
        pagination,
        AutoComplete
    },
    async mounted() {
        this.initialize();
        await this.getAllUsers();

        await this.checkAfterRequired('check')
        
        emitter.on('visible', this.onGlobalFilterVisible);
        
        emitter.off('checkAuditValidation')
        emitter.on('checkAuditValidation', (action:any) => {
            this.action = action;
            this.v$.sortedData.$touch();
            if(!this.v$.sortedData.$invalid){
                this.checkAfterRequired('save')
            }else{
                toast.error(`Validation Error`, {
                    timeout: 1000,
                    closeOnClick: true,
                    closeButton: 'button',
                    icon: true
                });
            }
        });
        
         this.userInfoFilteredDetails = {
              label: this.userInfo.name,
              value: this.userInfo._id,
            };
    },
    beforeUnmount() {
        emitter.off('visible', this.onGlobalFilterVisible);
    },
    computed: {
        ...mapGetters({ userInfo: "userInfo" }),
        sortedData: function (): any {
            return [...this.tableRow]
                .filter((row: any) => {
                    for (const key in this.filters) {
                        const inputValue = this.filters[key];
                        if (inputValue !== '' && row[key]) {
                            if (Number.isInteger(row[key])) {
                                if (row[key] !== Number(inputValue)) {
                                    return false;
                                }
                            } else {
                                if (!row[key].toLowerCase().includes(inputValue.toLowerCase())) {
                                    return false;
                                }
                            }
                        }
                    }
                    return true;
                })
                .sort((a, b) => {
                    let modifier = 1;
                    if (this.currentSortDir === 'desc') modifier = -1;
                    if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
                    if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
                    return 0;
                })
                .filter((row, index) => {
                    this.dynamicPagination = index + 1;
                    let start = (this.currentPage - 1) * this.pageSize;
                    let end = this.currentPage * this.pageSize;
                    if (index >= start && index < end) return true;
                });
        },
        columnNames: function (): any {
            const names = new Set();
            for (const key of this.headersData) {
                if (key != 'entityId' && key != '_id') names.add(key);
            }
            return names;
        }
    },
    watch: {
        visibility(newValue) {
            if (newValue == false) {
                this.initialize();
            }
        },
        tableRowData: {
            handler(newVal, oldVal) {
                this.tableRow = this.tableRowData;
                this.initialize();
            },
            deep: true
        }
    },
    methods: {
        getResizeColumnNames(): string[] {
            return Array.from(this.columnNames || []);
        },
        isInsideDetailsModal() {
            const root = this.$el as HTMLElement;
            if (!root || typeof root.closest !== 'function') {
                return false;
            }
            const overlay = document.querySelector('.details-modal-overlay') as HTMLElement | null;
            if (overlay && overlay.contains(root)) {
                return true;
            }
            return !!(root.closest('.details-modal') || root.closest('.details-in-modal') || root.closest('.details-modal-body'));
        },
        onGlobalFilterVisible(isBoolean: any) {
            const overlay = document.querySelector('.details-modal-overlay');
            const root = this.$el as HTMLElement;
            if (overlay && root && typeof overlay.contains === 'function' && !overlay.contains(root)) {
                return;
            }
            this.visibility = isBoolean;
            this.visibility == false ? (this.filters = {}) : '';
        },
        getColumnHeadWidth(column : any){
             if (column == 'team'  || column=='entity') {
                return 'width20';
             }else if(column == 'auditee' || column=='auditor'){
                return 'width30'
             } 
        },
        limitText (count:any) {
			// return `and ${count} other countries`
			// console.log('countcount',count)
		},
		asyncFind1(query:any){
            query=query.query
            this.searchValue = '';
			if(query == ''){
				this.auditorOptions = []
			}else if(query.length > 0){
				this.auditorOptions = this.userArray.filter((obj:any)=>{return obj.label.toLowerCase().includes(query.toLowerCase())})
			}
		},
        asyncFind(query:any){
            query=query.query
            this.searchValue = '';
			if(query == ''){
				this.auditeeOptions = []
			}else if(query.length > 0){
				this.auditeeOptions = this.auditeeList.filter((obj:any)=>{return obj.label.toLowerCase().includes(query.toLowerCase())})
			}
		},
        checkAfterRequired(action:any){
            this.validationErrors = this.sortedData.map((row:any) => {
                    return {
                        auditee: !row.auditee,
                        auditor: !row.auditor,
                        sameAuditorAuditee: row.auditee==''|| row.auditor==''?false:row.auditor.value === row.auditee.value
                    };
                });

                if(action == 'save'){
                    const hasErrors = this.validationErrors.some((errors:any) => 
                        errors.auditee || errors.auditor || errors.sameAuditorAuditee
                    );

                    if (hasErrors) {
                        // Prevent saving and show validation messages
                        // console.log('Prevent saving and show validation messages')
                    }else{
                        emitter.emit('auditValidationDone',this.action)
                        // console.log('auditValidationDoneauditValidationDoneauditValidationDone')
                    }
                }
        },
        getColumnLabel(columnName: any) {
			if (columnName == 'actionButton' || columnName == 'kpiDelete' || columnName == 'deleteIcon' || columnName == 'actionButtonAtCompliance' || columnName == 'actionButtonAtObjective' || columnName=='actionButtonForKPIs'){
                return '';
            }
            const column = this.columns.find((col: { key: any }) => col.key === columnName);
            return column ? column.value : columnName;
        },
        initialize() {
            this.tableRow = this.tableRowData;
            this.searchTableRow = this.tableRowData;

            this.tableRowData[0] == undefined ? '' : (this.entityId = this.tableRowData[0].entityId);
            // console.log('this.entityId', this.entityId);
        },
        paginationUpdations(currentPage: any, pageSize: any) {
            // console.log('Pagination processing... ', currentPage, pageSize);
            this.currentPage = currentPage;
            this.pageSize = pageSize;
        },
        sort(tableHead: any) {
            this.className = tableHead;
            if (tableHead === this.currentSort) {
                this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
            }
            this.currentSort = tableHead;
            this.classSort = this.currentSortDir === 'asc' ? 'sort_asc' : 'sort_desc';
        },
        toolTip(column: any, e: any, index: any, row: any, status: any) {
            this.tipText = (e.currentTarget?.textContent || row[column] || '').toString().trim();
            this.tipColumn = column;
            this.tipIndex = index;

            switch (status) {
                case 'text':
                    this.handleTextTooltip(e);
                    break;
                case 'circleButton':
                    if (e.offsetX < e.target.offsetWidth && e.offsetY < e.target.offsetHeight) {
                        this.pop = true;
                        this.styling.left = e.offsetX + e.target.offsetLeft + 13 + 'px';
                        this.styling.bottom = -18 + 'px';
                    }
            }
        },
        headerToolTip(column: any, e: any) {
            const label = this.getColumnLabel(column);
            const container = e.currentTarget;
            if (label && container && this.isTextOverflowed(container)) {
                this.pop = true;
                this.tipText = label;
                this.tipColumn = column;
                this.tipIndex = 'header';
                this.styling.left = e.offsetX + 38 + 'px';
                this.styling.bottom = -75 + 'px';
            } else {
                this.pop = false;
            }
        },
        handleTextTooltip(e: any) {
            const container = e.currentTarget.classList?.contains('table-ellipsis')
                ? e.currentTarget
                : e.currentTarget.closest('.table-ellipsis');
            if (container && this.isTextOverflowed(container)) {
                this.pop = true;
                this.styling.left = e.offsetX + 38 + 'px';
                this.styling.bottom = -75 + 'px';
            } else {
                this.pop = false;
            }
        },
        isTextOverflowed(element: any) {
            return element.scrollWidth > element.clientWidth || element.scrollHeight > element.clientHeight;
        },
        getTeamName(deptId: any) {
            let user = this.departments.find((obj: any) => {
                return obj._id == deptId;
            });
            if (user == undefined) {
                let empty = '';
                return empty;
            } else {
                return user.displayName;
            }
        },
         getLocationName(locationId: any) {
            let user = this.locations.find((obj: any) => {
                return obj.value == locationId;
            });
            if (user == undefined) {
                let empty = 'N/A';
                return empty;
            } else {
                return user.label;
            }
        },
        doFalse() {
            this.pop = false;
        },
        async getAllUsers() {
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/users/getAll`).then((res: any) => {
                this.users = res.data;
            });
            for (var i = 0; i < this.users.length; i++) {
                if(this.users[i].roleId!=10217){
                    this.auditeeList.push({ label: this.users[i].name, value: this.users[i]._id });
                }
                this.optionsUserArray.push({ label: this.users[i].name, value: this.users[i]._id });
            }
        },
    }
});
</script>
